<template>
	<modal
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<span v-if="!data">{{ $t('Add Display Size') }}</span>
			<span v-else>{{ $t('Edit Display Size') }}</span>
		</template>
		<template slot="body">
			<form @submit.prevent="save">
				<!-- Name -->
				<div class="form-group">
					<label>{{ $t('Name') }}</label>
					<input
						type="text"
						name="name"
						class="form-control"
						v-model="name"
						required
					/>
				</div>
				<!-- Width -->
				<div class="form-group">
					<label>{{ $t('Width') }}</label>
					<input
						type="number"
						name="width"
						class="form-control"
						v-model="width"
						required
					/>
				</div>
				<!-- Height -->
				<div class="form-group">
					<label>{{ $t('Height') }}</label>
					<input
						type="number"
						name="height"
						class="form-control"
						v-model="height"
						required
					/>
				</div>
				<!-- Submit -->
				<button
					type="submit"
					class="btn btn-submit btn-primary mt-3 mb-3"
					:class="{ 'is-loading': isSaving }">
					{{ $t('Create Display Size') }}
				</button>
			</form>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import displaySizesApi from '@/api/display-sizes';

export default {
	name: 'DisplaySizeForm',
	props: {
		data: {
			type: Object,
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			name: '',
			width: 0,
			height: 0,
			isSaving: false,
		};
	},
	methods: {
		save() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				const item = response.data;
				const message = response.message;
				this.$emit('saved', item);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Display Size',
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Display Size',
					text: message,
				});
				this.isSaving = false;
			};
			if (this.data) {
				displaySizesApi.update(this.data.id, params, callback, errorCallback);
			} else {
				displaySizesApi.create(params, callback, errorCallback);
			}
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
			if (this.data) {
				this.setData(this.data);
			}
		},
		reset() {
			this.name = '';
			this.width = 0;
			this.height = 0;
		},
		setData(data) {
			this.name = data.name;
			this.width = data.width;
			this.height = data.height;
		},
	},
	computed: {
		params() {
			const name = this.name.trim();
			const width = this.width;
			const height = this.height;
			const params = {
				name,
				width,
				height,
			};
			return params;
		},
	},
	created() {
		this.initData();
	},
	watch: {
		name(val) {
			this.name = val.replace(/[^A-Z0-9 -]/gi, '');
		},
	},
};
</script>
